import { getIcConfig } from "@/lib/network";

/** True on mainnet production money stack. */
export function isProductionOracle(): boolean {
	return getIcConfig().network === "production";
}

/** Local replica only — hybrid browser market_fallback for UI marks. */
export function isLocalOracle(): boolean {
	return getIcConfig().network === "local";
}

/**
 * Play + production: vault marks are chain-only (no browser prices for CR/mint).
 * Hybrid market_fallback is local-only — do not use !isProductionOracle() as the gate.
 */
export function isChainOnlyOracleMarks(): boolean {
	return !isLocalOracle();
}

/** Play Mode or local replica — show play/local banners. */
export function isPlayOrLocalOracle(): boolean {
	const n = getIcConfig().network;
	return n === "local" || n === "play";
}
